/**
 * Formatează un preț din bani (integer) în RON cu 2 zecimale.
 * Ex: 1590 → "15,90 lei"
 */
export function formatPrice(bani: number): string {
  const ron = bani / 100;
  return `${ron.toFixed(2).replace('.', ',')} lei`;
}

/**
 * Calculează discount-ul pe baza regulilor DDS.
 * Bundle: totalItems = componentsPerUnit × qty
 *   <6 → 0%, 6-11 → 5%, 12+ → 10%
 * Normal: qty ≥ 6 → 5%
 */
export function calculateDiscount(
  isBundle: boolean,
  componentsPerUnit: number,
  qty: number
): number {
  if (isBundle) {
    if (qty >= 3) return 10;
    if (qty === 2) return 5;
    const totalItems = componentsPerUnit * qty;
    if (totalItems >= 12) return 10;
    if (totalItems >= 6) return 5;
    return 0;
  }
  return qty >= 6 ? 5 : 0;
}

/**
 * Calculează costul transportului.
 * Sub 139 RON (13900 bani) → 1500 bani (15 lei)
 * Peste 139 RON → 0 (gratuit)
 */
export const FREE_SHIPPING_THRESHOLD = 13900;
export const SHIPPING_COST = 1500;

export function calculateShipping(subtotalBani: number): number {
  return subtotalBani >= FREE_SHIPPING_THRESHOLD ? 0 : SHIPPING_COST;
}

/**
 * Trunchiază un string la un număr maxim de caractere.
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}…`;
}

/**
 * Verifică dacă un produs e indisponibil.
 */
export function isProductUnavailable(tags: string[]): boolean {
  return tags.some((tag) => tag.toLowerCase() === 'indisponibil');
}
